import React, { forwardRef, useMemo } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import RedhatACSMappingForm from "./RedhatACSMappingForm";

const RedhatACSCredentialsForm = forwardRef((props, ref) => {
  const fields = useMemo(
    () => [
      {
        name: "apiEndpoint",
        label: "API Endpoint",
        rules: [urlRegexValidator],
        required: true
      },
      {
        name: "apiToken",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
      },
    ],
    []
  );
  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={RedhatACSMappingForm}
    />
  );
});

export default RedhatACSCredentialsForm;
